import { useEffect, useRef } from "react";
import { Column, Loader } from "@amzn/meridian";
import { useAppSelector } from "src/store/store";
import inspectionService from "src/services/inspectionService";

interface AutoCalculateStepProps {
  questionId: string;
  onComplete: () => void;
}

/**
 * A non-visual step that triggers the backend auto-calculate endpoint for a
 * given question. It shows a loading spinner while the API call is in flight
 * and automatically advances to the next step once it completes.
 */
const AutoCalculateStep: React.FC<AutoCalculateStepProps> = ({ questionId, onComplete }) => {
  const { inspectionId } = useAppSelector((state) => state.workflow);
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    inspectionService
      .autoCalculate(inspectionId, questionId)
      .then(() => {
        onComplete();
      })
      .catch((err) => {
        console.error("Auto-calculate failed:", err);
        // Still advance so the workflow doesn't get stuck
        onComplete();
      });
  }, [inspectionId, questionId, onComplete]);

  return (
    <Column height="100%" alignmentHorizontal="center" alignmentVertical="center">
      <Loader size="large" />
    </Column>
  );
};

export default AutoCalculateStep;
